mutation LogToSlack($input: LogToSlackInput!) {
  logToSlack(input: $input)
}
